import {DateTime} from "luxon"
import { siteTZ } from '../database/apiv2SiteAccessor';
import { mapTZAbbr } from "./TimeZone";

// returns NaN for all failures. takes a number, date or string, returns elapsed ms.
export default function TimeSince(moment)
{
    const ms = toMs(moment);
    return isNaN(ms) ? ms : timeSince_ms(ms);
}

// returns NaN for all failures. takes a number, date or string, returns ms.
function toMs(moment)
{
    if (!moment) return NaN;
    if (typeof moment === 'number') return moment;
    if (typeof moment === 'string') return new Date(moment).getTime();

    if ("undefined" === typeof(moment["getTime"])) return NaN;
    return moment.getTime();
}

function timeSince_ms (milliseconds) {
    return Math.abs (Date.now() - milliseconds);
}

export function timeAgo (datetime) {
    const lc = sanitizeDateTime(datetime);
    const temp = new Date();
    return Math.abs (temp.getTime() - lc.getTime());
}
export function UTCTimeAgo (datetime) {
    const dt = new Date();
    const lc = sanitizeDateTime (datetime, {zone: 'UTC'})
    return Math.abs (dt.getTime() - lc.getTime());
}
function timeAgoObj (ms) {
    const msToMinute = 1000 * 60
    const days = Math.trunc (ms / (msToMinute * 60 * 24))
    let remainder = ms - days * msToMinute * 60 * 24
    const hours = Math.trunc (remainder / (msToMinute * 60))
    remainder = remainder - hours * msToMinute * 60
    const minutes = Math.trunc (remainder / msToMinute)
    return {day: days, hour: hours, min: minutes}
}
export function formatTimeAgo (ms) {
    const ta = timeAgoObj (ms)
    if (ta.day > 0) 
        return ta.day + " days " + ta.hour + " hours"
    else if (ta.hour > 0)
        return ta.hour + " hours " + ta.min + " minutes"
    else return ta.min + " minutes"
}
export function shortTimeAgo (dt) {
    if (!dt) 
        return 'Never'
    const ago = Math.abs (Date.now() - dt.getTime())
    const ta = timeAgoObj (ago)
    if (ta.day > 0) 
        return ta.day+"d:"+ta.hour+"h:"+ta.min+"m"
    if (ta.hour > 0)
        return ta.hour+"h:"+ta.min+"m"
    return ta.min+'m'
}
// sanitize only if present
export function cleanDateTime(strDate, opts={locale: 'en-US', zone: 'local'}) {
    if (typeof strDate?.getTime === 'function') {
        return strDate
    }
    const result = parseDateTime (strDate, opts)
    return result.invalid ? undefined : result.toJSDate()
}
export function sanitizeDateTime (datetime, opts={locale: 'en-US', zone: 'local'}) {
    const dt = cleanDateTime (datetime, opts)
    return dt ?? new Date(2020, 0, 1)
}
export function parseDateTime (string, opts={locale: 'en-US', zone: 'local'}) {
    if (typeof string === 'string') {
        let result = DateTime.fromSQL(string, opts)
        if (result.invalid)
            result = DateTime.fromISO(string, opts);
        if (result.invalid)
            result = DateTime.fromHTTP(string, opts)
        if (result.invalid)
            result = DateTime.fromRFC2822(string, opts)
        if (result.invalid) {
            //below busted Feb 2023. tt now puts literal U+202f before AM/PM 
            //result = DateTime.fromFormat(datetime, 'D tt', opts)
            result = DateTime.fromFormat(string, 'D h:mm:ss a', opts)
        }
        if (result.invalid) {
            result = DateTime.fromFormat(string, 'D hh:mm:ss a', opts)
        }
        if (result.invalid) {
            result = DateTime.fromFormat(string, 'd-m-yyyy', opts)
        }
        if (result.invalid) {
            result = DateTime.fromFormat(string, 'MMM d, yyyy', opts)
        }
        return result
    }
    return {invalid:true}
}
export function apiFormat(anytime) {
    let temp = anytime.toJSON();    // YYYY-MM-DDTHH:mm:ss.nnnZ
    return temp.replace("T", "%20");
}

export function parsetoDCAPTime (props, timeStr) {
    const tz = siteTZ(props.getActiveSite(), 'local')
    const parseZone = tz === 'local' ? tz : mapTZAbbr (tz)
    return sanitizeDateTime(timeStr, {locale: 'en-US', zone: parseZone})
}
export function between(x, min, max) {
    const dx = toMs(x);
    const dmin = toMs(min);
    const dmax = toMs(max);
    if (isNaN(dx) || isNaN(dmin) || isNaN(dmax))
        return false;
    return dx >= dmin && dx <= dmax;
  }
  export function hoursDiff(t1, t2) {
      return (t1.getTime() - t2.getTime()) / (1000 * 60 * 60)
  }
  export function hoursAdd (t1, hours) {
      let result = new Date (t1.getTime())
      result.setHours(t1.getHours()+hours);
      return result
  }
  export function dateFormat (dt) {
    const dtOptions = {year: 'numeric', month: 'short', day: 'numeric'}
    return dt.toLocaleString("en-us", dtOptions)
  }
  export function mediumFormat (dt) {
    const dtOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric' };
    return dt.toLocaleString("en-US", dtOptions)
  }
  export function timeOfDay(dt, tzOffset=0) {
    let hour = dt.getHours()-Math.floor(tzOffset/60);
    hour = hour < 0 ? hour+24: hour
    //const min  = dt.getMinutes();
    const min = 0
    return (hour < 10 ? "0" : "") + hour + ":"+ (min < 10 ? "0" : "") + min
 }
 export function inverseTimeOfDay (strTime, tzOffset=0) {
    const dtOpts = { year: 'numeric', month: 'numeric', day: 'numeric'};
    const strDt = new Date().toLocaleDateString("en-ca", dtOpts)
    const strHour = strTime.substring(0, strTime.indexOf(':'))
    const hour = (parseInt(strHour)+Math.floor(tzOffset/60)) % 24
    const strhour = (hour < 10 ?'0':'') + hour
    return strDt+" "+strhour+":00:00"
 }
 export function isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  export function dateOnly (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  }
